import GetFaqCategoryResponse from '../CRM/Responses/FaqCategoryResponse';

import Faq from './Faq';
import Model from './Model';

export default class FaqCategory extends Model {
    id: number;
    language_id: number;
    translation_id: number;
    name: string;
    slug: string;
    faqs: Faq[] = [];

    constructor(faqCategory: Partial<GetFaqCategoryResponse>) {
        super();
        this.assignDataToProps(faqCategory, ['id', 'language_id', 'translation_id', 'name', 'slug', 'faqs']);
        this.faqs = faqCategory.faqs || [];
    }
}
